<template>
  <div class="cmp-favorites-control">

    <a v-if="(!isFavoriteComputed && !touched) || (touched && !isFavorite)"
      @click="addToFavorites()"
      class="favorites-icon add-to">
      <i class="fa fa-heart-o" aria-hidden="true"></i>
      <span v-if="useDescription" v-translation="{ type: 'button', code: 'button_add_to_favorites' }" class="add-to-desc"></span>
    </a>

    <a v-else
      @click="removeFromFavorites()"
      class="favorites-icon remove">
      <i class="fa fa-heart" aria-hidden="true"></i>
      <span v-if="useDescription" v-translation="{ type: 'button', code: 'button_remove_from_favorites' }" class="remove-desc"></span>
    </a>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { Product } from 'src/models/product.model';
export default {
  props: {
    useDescription: { type: Boolean, required: false, default: false },
    product: { type: Product, required: true }
  },
  data () {
    return {
      touched: false,
      isFavorite: false
    };
  },
  computed: {
    ...mapGetters(['addProductToListEndpoint', 'removeProductFromListEndpoint', 'customerId', 'clientCode']),
    isFavoriteComputed () {
      // BESPOKE GS
      // Changed orderlist to favorites
      return this.product.includedInCustomerLists.includes('orderlist');
      // END BESPOKE GS
    }
  },
  methods: {
    addToFavorites () {
      // BESPOKE GS-440
      // Add product to orderlist instead of favorites
      const endpoint = `${this.addProductToListEndpoint}?productCode=${this.product.id}&debtorId=${this.customerId}&listId=orderlist`;
      // END BESPOKE GS-440
      axios.post(endpoint).then(res => {
        this.touched = !this.touched;
        this.isFavorite = true;
      });
    },
    removeFromFavorites () {
      // BESPOKE GS-440
      // Add product to orderlist instead of favorites
      const endpoint = `${this.removeProductFromListEndpoint}?productCode=${this.product.id}&debtorId=${this.customerId}&listId=orderlist`;
      // END BESPOKE GS-440
      axios.delete(endpoint).then(res => {
        this.touched = !this.touched;
        this.isFavorite = false;
      });
    }
  },
  created () {
    // BESPOKE GS-440
    // Add product to orderlist instead of favorites
    this.isFavorite = this.product.includedInCustomerLists.includes('orderlist');
    // END BESPOKE GS-440
  }
}
</script>

<style>

</style>
